// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"zq-z","breadcrumbForward":"Aq-z","breadcrumbBack":"Bq-z","selected":"Cq-z"};